export default "/8522fe2631ecefb1e3967be9883671f05392a386/a70fe28c30edbe909cade8425716fdee.svg";